import React from "react";
import { ModalType } from "../../data-access";
import { DiscountModal } from "../billing/discount-modal";
import { FeedbackModal } from "../feedback";
import { InviteTeamMembersModal } from "../team/invite-team-members-modal";
import { OfflineModal } from "../modals-container/offline-modal";
import { UpwexApiKeyModal } from "../upwex-api/upwex-api-key-modal";

interface IModalsFactoryProps {
  type: ModalType | null;
  onClose: () => void;
  [key: string]: unknown;
}

export const ModalsFactory = ({
  type,
  onClose,
  ...rest
}: IModalsFactoryProps): JSX.Element | null => {
  switch (type) {
    case ModalType.Discounts:
      return <DiscountModal onClose={onClose} {...rest} />;
    case ModalType.InviteTeamMembers:
      return <InviteTeamMembersModal onClose={onClose} {...rest} />;
    case ModalType.UpwexApiKey:
      return <UpwexApiKeyModal onClose={onClose} {...rest} />;
    case ModalType.Offline:
      return <OfflineModal />;
    case ModalType.Feedback:
      return <FeedbackModal onClose={onClose} />;
  }

  return null;
};
